module.exports = __webpack_public_path__ + "static/media/ic-csv-file.752d4eec.svg";